import { render, staticRenderFns } from "./ActualizarCostosMP.vue?vue&type=template&id=23563e96&"
import script from "./ActualizarCostosMP.vue?vue&type=script&lang=js&"
export * from "./ActualizarCostosMP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports